export const APIs_Txt2Img = {
  "sd.inpainting": "/txt2img/sd.inpainting",
  "sd.outpainting": "/txt2img/sd.outpainting",
  sd: "/txt2img/sd",
};

export const APIs_Img2Img = {
  sd: "/img2img/sd",
  sr: "/img2img/sr",
  semantic2img: "/img2img/semantic2img",
  inpainting: "/img2img/inpainting",
};

export const AI_CREATOR_APIs = {
  drawCreate: "/ai_creator/draw/create",
  operateCreate: "/ai_creator/operate/create",
};

export const API_HD_IMAGE = "/hdimage";
